import { Query } from '@apollo/client/react/components';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import { withRouter } from 'react-router';

import { withMediaListener } from '@xingternal/util';

import similarJobs from '@/components/job-posting/components/withSimilarJobs/similar-jobs.query.graphql';
import { hasSidebarJobs as getHasSidebarJobs, getSimilarJobsQueryLimit } from '@/components/job-posting/helpers';
import { fromQuery } from '@/helpers/query-string';
import { useLoginStates } from '@/hooks';
import { jobShape } from '@/proptypes/job';

import { Navigation } from '../';
import { getSimilarJobsPager } from '../../navigation-selectors';

const LI_CONSUMER = 'loggedin.web.jobs.posting.similar';
const LO_CONSUMER = 'loggedout.web.jobs.posting.similar';

export const SimilarJobsNavigation = ({ className, match, location, job, matchedMedia }) => {
  const { isLoggedOut } = useLoginStates();

  const queryParams = fromQuery(location.search.substr(1));
  const id = queryParams.similar_to || job.id;

  const hasSidebarJobs = getHasSidebarJobs({ job, matchedMedia });
  const limit = getSimilarJobsQueryLimit(hasSidebarJobs);

  return (
    <Query
      query={similarJobs}
      variables={{
        id,
        consumer: isLoggedOut ? LO_CONSUMER : LI_CONSUMER,
        limit,
      }}
      errorPolicy="all"
    >
      {({ data, loading }) => {
        const similarJobs = { items: R.pathOr([], ['viewer', 'similarJobs', 'collection'], data) };
        const { context } = getSimilarJobsPager({ similarJobs }, { match, location, job });

        return !loading && <Navigation context={context} className={className} />;
      }}
    </Query>
  );
};

SimilarJobsNavigation.propTypes = {
  job: jobShape,
  matchedMedia: PropTypes.string,
  className: PropTypes.string,
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(withMediaListener(SimilarJobsNavigation));
